// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NavigationView {\n  margin-block-end: 0;\n}\n.NavigationView fieldset {\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
